<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M8.94417 4.64666C10.8853 4.41533 12.8488 4.82567 14.5349 5.81503C16.2209 6.80439 17.5368 8.31839 18.2817 10.1258C18.3511 10.3129 18.3511 10.5187 18.2817 10.7058C17.9754 11.4483 17.5707 12.1462 17.0783 12.7808"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M11.7367 12.2151C11.2652 12.6704 10.6336 12.9224 9.97815 12.9167C9.32266 12.911 8.69563 12.6481 8.23211 12.1846C7.76859 11.7211 7.50567 11.094 7.49997 10.4386C7.49428 9.78306 7.74626 9.15156 8.20166 8.68005"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M14.5658 14.9992C13.4604 15.654 12.2271 16.0633 10.9495 16.1995C9.67188 16.3356 8.37996 16.1954 7.16136 15.7882C5.94276 15.3811 4.82599 14.7166 3.88684 13.8398C2.94769 12.963 2.20813 11.8944 1.71833 10.7067C1.64888 10.5196 1.64888 10.3138 1.71833 10.1267C2.45719 8.33487 3.75723 6.83103 5.42333 5.84082"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M1.66667 2.08337L18.3333 18.75"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconEyeOff',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
